// extracted by mini-css-extract-plugin
export default {"wrapper":"form_wrapper__KQr1w"};